import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop } from "vue-property-decorator";
import { LessonPlanLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import { VCSLevelModel } from "@/models/title-list-model";
import LabelText from "@/components/label-text/label-text.vue";

@Component({
	components: {
		"a-select": Select,
		"a-select-option": Select.Option,
		LabelText
	}
})
export default class UnitSelect extends Vue {
	@Prop() units!: VCSLevelModel[];
	@Prop() value!: string;
	@Prop() containerStyle!: any;
	@Prop() labelStyle!: any;
	@Prop() selectStyle!: any;

	get unitText(): string {
		return fmtMsg(LessonPlanLocale.LessonPlanListUnitTitle);
	}

	onUnitChanged(value: number): void {
		this.$emit(
			"onUnitChanged",
			this.units.find((v) => v.id === value)
		);
	}
}
